import _implicitStylesheets from "./link.css";
import _implicitScopedStylesheets from "./link.scoped.css?scoped=true";
import _amcAnalyticsInstrument from "amc/analyticsInstrument";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "type": "link"
};
const stc1 = {
  "content": true
};
const stc2 = {
  attrs: {
    "name": "start"
  },
  key: 3
};
const stc3 = [];
const stc4 = {
  key: 4
};
const stc5 = {
  attrs: {
    "name": "end"
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, gid: api_scoped_id, ncls: api_normalize_class_name, s: api_slot, h: api_element, d: api_dynamic_text, t: api_text, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("amc-analytics-instrument", _amcAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("a", {
    classMap: stc1,
    attrs: {
      "href": $cmp.href,
      "aria-label": $cmp.ariaLabel,
      "aria-labelledby": api_scoped_id($cmp.ariaLabelledBy)
    },
    key: 1,
    on: {
      "slotchange": _m1 || ($ctx._m1 = api_bind($cmp.handleSlotChange))
    }
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.slotsClasses.start),
    key: 2
  }, [api_slot("start", stc2, stc3, $slotset)]), api_slot("", stc4, [api_text(api_dynamic_text($cmp.label))], $slotset), api_element("div", {
    className: api_normalize_class_name($cmp.slotsClasses.end),
    key: 5
  }, [api_slot("end", stc5, stc3, $slotset)])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["", "end", "start"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1pr1mcdqssh";
tmpl.legacyStylesheetToken = "undefined-_link";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
